<template>
	<v-container fluid>
		<header class="d-flex">
			<h1 class="title mr-auto">이벤트광고 관리</h1>
			<v-btn class="pa-2" color="primary" @click="form_dialog = true"
				>등록</v-btn
			>
		</header>

		<v-card>
			<v-card-text class="pa-5 pb-0">
				<v-form @submit.prevent="loadList(1)" :novalidate="false">
					<input type="submit" hidden />
					<v-row dense>
						<v-col class="d-flex">
							<v-select
								label="검색영역"
								v-model="params.search_field"
								:items="SEARCH_FIELD"
								dense
							/>
							<v-text-field
								:label="field.text"
								v-model="params[params.search_field]"
								v-for="field in SEARCH_FIELD"
								v-if="params.search_field == field.value"
								:key="field.value"
								dense
							/>
						</v-col>

						<v-col class="d-flex text-center ml-7">
							<v-text-field
								v-model="params.startOn"
								type="date"
								label="등록일 시작"
								max="2038-01-18"
								min="1970-01-02"
								dense
							/>
							~
							<v-text-field
								v-model="params.endOn"
								type="date"
								label="등록일 종료"
								max="2038-01-18"
								min="1970-01-02"
								dense
							/>
						</v-col>

						<v-col>
							<v-radio-group
								v-model="params.isDisplay"
								label="노출상태:"
								dense
								mandatory
								row
								class="ml-7"
							>
								<v-radio :value="null" label="전체" />
								<v-radio :value="1" label="노출" />
								<v-radio :value="0" label="비노출" />
							</v-radio-group>
						</v-col>
					</v-row>

					<v-row dense>
						<v-col class="d-flex col-6">
							<v-select
								label="구분"
								v-model="params.division"
								:items="_.keys(DIVISION)"
								dense
								clearable
								class="mr-5"
							/>
							<v-select
								label="분류"
								v-model="params.divisionType"
								:items="
									params.division
										? DIVISION[params.division].types
										: []
								"
								dense
								clearable
								class="mr-5"
							/>
						</v-col>

						<v-col class="d-flex col-6">
							<v-select
								label="카테고리1"
								v-model="params.idFirstCategory"
								:items="category1_list"
								item-text="firstCategoryText"
								item-value="idFirstCategory"
								dense
								clearable
								class="mr-5"
							/>
							<v-select
								label="카테고리2"
								v-model="params.idSecondCategory"
								:items="getSelectedCategory2List()"
								item-text="secondCategoryText"
								item-value="idSecondCategory"
								dense
								clearable
								class="mr-5"
							/>
							<v-select
								label="카테고리3"
								v-model="params.idThirdCategory"
								:items="getSelectedCategory3List()"
								item-text="thirdCategoryText"
								item-value="idThirdCategory"
								dense
								clearable
								class="mr-5"
							/>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>

			<v-card-actions class="pa-3 pt-0">
				<v-spacer />
				<v-btn small @click="initSearch()">초기화</v-btn>
				<v-btn small color="primary" @click="loadList(1)">검색</v-btn>
			</v-card-actions>
		</v-card>

		<v-data-table
			hide-default-footer
			@page-count="20"
			must-sort
			class="mt-5"
			:headers="data_table.headers"
			:items="data_table.items"
			:page.sync="data_table.options.page"
			:server-items-length="data_table.total"
			:options.sync="data_table.options"
			:loading="data_table.loading"
		>
			<template v-slot:item.title="{ item }">
				<a @click="openForm(item.id)">{{ item.title }}</a>
			</template>

			<template v-slot:item.counter.display_count="{ item }">
				<v-btn
					x-small
					@click="
						openDailyAdCounterModal(item.title, item.counter.id)
					"
					:disabled="!item.counter.display_count"
					>{{ item.counter.display_count.toLocaleString() }}</v-btn
				>
			</template>

			<template v-slot:item.counter.action_count="{ item }">
				<v-btn
					x-small
					@click="
						openDailyAdCounterModal(item.title, item.counter.id)
					"
					:disabled="!item.counter.display_count"
					>{{ item.counter.action_count.toLocaleString() }}</v-btn
				>
			</template>

			<template v-slot:item.action="{ item }">
				<v-icon small class="mr-2" @click="openForm(item.id)"
					>mdi-pencil</v-icon
				>
			</template>
		</v-data-table>

		<v-pagination
			circle
			v-model="data_table.options.page"
			:length="data_table.page_length"
			:total-visible="11"
		/>

		<event-ad-form
			:form_dialog="form_dialog"
			:id="selected_event_ad_id"
			@close="closeForm"
		/>
	</v-container>
</template>

<script>
	import _ from 'lodash';
	import moment from 'moment';
	import EventAdForm from './_form.vue';
	import AdService from '@/lib/AdService';

	const _params = {
		search_field: 'title',
		periodType: '등록일',
		idFirstCategory: null,
		idSecondCategory: null,
		idThirdCategory: null,
	};

	export default {
		components: {
			EventAdForm,
		},
		data() {
			return {
				selected_event_ad_id: null,
				form_dialog: false,

				data_table: {
					loading: false,
					options: {
						page: 1,
						itemsPerPage: 20,
						sortBy: ['id'],
						sortDesc: [true],
					},
					page_length: 0,
					headers: [
						{ text: '광고번호', value: 'id' },
						{
							text: '등록일시',
							value: 'created_at',
							sortable: false,
						},
						{ text: '구분', value: 'division', sortable: false },
						{
							text: '분류',
							value: 'division_type',
							sortable: false,
						},
						{ text: '제품', value: 'cnt', sortable: false },
						{ text: '제목', value: 'title', sortable: false },
						{ text: '광고문구', value: 'intro', sortable: false },
						{
							text: '시작일시',
							value: 'start_on',
							sortable: false,
						},
						{ text: '종료일시', value: 'end_on', sortable: false },
						{
							text: '노출수',
							value: 'counter.display_count',
							sortable: false,
						},
						{
							text: '클릭수',
							value: 'counter.action_count',
							sortable: false,
						},
						{ text: '기능', value: 'action', sortable: false },
					],
					items: [],
					total: 0,
				},

				params: {
					..._params,
					...this.$route.query,
				},
				category1_list: [],
				category2_list: [],
				category3_list: [],

				DIVISION: {
					외부: {
						color: 'purple',
						types: ['특가', '증정', '체험단', '샘플링'],
					},
					내부: {
						color: 'red',
						types: ['이벤트', '캐스트'],
					},
				},

				SEARCH_FIELD: [
					{ value: 'title', text: '제목' },
					{ value: 'idProduct', text: '제품번호' },
					{ value: 'productTitle', text: '제품명' },
					{ value: 'intro', text: '광고문구' },
					{ value: 'divisionId', text: '이벤트/캐스트 번호' },
				],
			};
		},

		async created() {
			await this.loadCategoryList();
		},

		watch: {
			'data_table.options': {
				handler() {
					this.loadList();
				},
				deep: true,
			},
			'params.idFirstCategory'(v) {
				if (!v) this.params.idSecondCategory = null;
			},
			'params.idSecondCategory'(v) {
				if (!v) this.params.idThirdCategory = null;
			},
			'params.division'(v) {
				if (!v) this.params.divisionType = null;
			},
			'params.search_field'(v) {
				for (const name of _.map(this.SEARCH_FIELD, 'value')) {
					this.params[name] = null;
				}
			},
		},

		methods: {
			async loadCategoryList() {
				const { data } = await this.$axiosAdminJS.get('/category');
				this.category1_list = data.category1_list;
				this.category2_list = data.category2_list;
				this.category3_list = data.category3_list;
			},
			getSelectedCategory2List() {
				if (this.params.idFirstCategory) {
					return _.filter(this.category2_list, {
						idFirstCategory: this.params.idFirstCategory,
					});
				}
			},
			getSelectedCategory3List() {
				if (
					this.params.idFirstCategory &&
					this.params.idSecondCategory
				) {
					return _.filter(this.category3_list, {
						idSecondCategory: this.params.idSecondCategory,
					});
				}
			},

			async loadList(page) {
				if (this.data_table.loading) return;
				if (page) {
					this.data_table.options.page = page;
				}

				this.data_table.loading = true;
				const params = {
					...this.params,
					offset:
						(this.data_table.options.page - 1) *
						this.data_table.options.itemsPerPage,
					limit: this.data_table.options.itemsPerPage,
					order: _.first(this.data_table.options.sortDesc)
						? 'desc'
						: 'asc',
					startOn: this.params.startOn
						? moment(this.params.startOn).toISOString()
						: null,
					endOn: this.params.endOn
						? moment(this.params.endOn + ' 23:59:59').toISOString()
						: undefined,
				};
				const { data } = await this.$axiosAdmin2.get(`/api/event/ad`, {
					params: _.pickBy(
						params,
						v => v !== undefined && v !== null && v !== ''
					),
				});

				this.data_table.total = data.fetch_count;
				this.data_table.page_length =
					parseInt(
						data.fetch_count / this.data_table.options.itemsPerPage
					) + 1;

				const { ads } = await AdService.getTargetAdList(
					'GP0041',
					_.map(data.event_ad_list, 'id')
				);

				this.data_table.items = data.event_ad_list.map(event_ad => {
					event_ad.created_at = moment(event_ad.created_at).format(
						'YYYY-MM-DD HH:mm'
					);
					event_ad.start_on = event_ad.start_on
						? moment(event_ad.start_on).format('YYYY-MM-DD HH:mm')
						: '-';
					event_ad.end_on = event_ad.end_on
						? moment(event_ad.end_on).format('YYYY-MM-DD HH:mm')
						: '-';
					event_ad.counter = _.find(ads, { ref_id: event_ad.id }) || {
						display_count: 0,
						action_count: 0,
					};
					return event_ad;
				});
				this.data_table.loading = false;

				if (this.params.openform) {
					const copyQuery = { ...this.$route.query };
					delete copyQuery.openform;
					await this.$nextTick();
					await this.$router.replace({ query: copyQuery });
					this.openForm(this.params.id);
				}
			},

			openForm(id) {
				this.selected_event_ad_id = id;
				this.form_dialog = true;
			},

			closeForm($event, reload = false, page = 1) {
				this.selected_event_ad_id = null;
				this.form_dialog = false;
				if (reload) {
					this.loadList(page);
				}
			},

			openDailyAdCounterModal(title, id) {
				if (!id) return;

				this.$store.commit('modal/toggleModal', {
					id: 'AdDetailTotal',
					contsTitle: title,
					params: { id },
				});
			},

			initSearch() {
				this.params = _.cloneDeep(_params);
			},

			remove(id) {
				alert('삭제 기능은 구현돼지 않았습니다.');
			},
		},
	};
</script>

<style lang="scss" scoped>
	.v-select {
		min-width: 12em;
		max-width: 12em;
	}
</style>
